angular.module('content.widgets.EventsWidgetController', [
  'global',
  'content.widgets.EventsWidgetService'
])

/**
 * The EventsWidgetController manages scope logic and user
 * interaction.
 *
 * @class EventsWidgetController
 * @constructor
 * @module content.widgets.EventsWidgetController
 **/
.controller('EventsWidgetController', [
  '$scope',
  '$rootScope',
  'EventsWidgetService',
  function ($scope, $rootScope, EventsWidgetService) {
    'use strict';

    $scope.model = {
      content: EventsWidgetService.content
    };

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      if ($rootScope.report.content.events.length > 0) {
        $scope.model.content = $rootScope.report.content;
      }
      $scope.user = $rootScope.user;
      $scope.model = EventsWidgetService.formatReports($scope.model);
    }

    initialize();
  }
]);
